<template>
  <div class="view users">

  <box :label="'Brugere'">

    <table class="table-a">
      <thead>
        <tr>
          <th>Fornavn</th>
          <th>Administrator?</th>
        </tr>
      </thead>
      <tr v-for="(user,i) in users">
        <td>{{user.first_name}}</td>
        <td>{{user}}</td>
      </tr>
    </table>

    <btn>Opret ny bruger</btn>

  </box>




  </div>
</template>

<script>
import mixins from '../mixins.js';
import helpers from '../helpers.js';
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Inputfield from '.././components/Inputfield'
import Avatar from '.././components/Avatar'
export default {
  components: { Box, Inputfield, Btn, Avatar },
  name: 'users',
  mixins: [ mixins.db, mixins.generic ],
  data: function () {
    return {
      globals: this.$parent.globals,
    }
  },
  methods: {



  },//methods

}
</script>



// WEBPACK FOOTER //
// Users.vue?bb648b78